import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Logo from '../Logo';
import DepartmentBox from '../DepartmentBox/DepartmentBox';
import { Desktop, Mobile } from '../MediaQuery';
import HeaderWrapper from './styled/HeaderWrapper';
import ActionLinks from './ActionLinks/ActionLinks';
import Hamburger from './mobile/Hamburger';
import MagnifyingGlass from './mobile/MagnifyingGlass';
import SearchBox from '../SearchBox/SearchBox';
import { ShoppingBag, ShoppingBagText } from './styled/ShoppingBag';
import { LeftColumn, LogoRow, NavigationRow, RightColumn } from './styled/HeaderRows';
import NavigationMenuDesktop from '../NavigationMenu/desktop/NavigationMenuDesktop';
import NavigationMenuMobile from '../NavigationMenu/mobile/NavigationMenuMobile';
import NavigationMenuUnderlay from '../NavigationMenu/mobile/styled/NavigationMenuUnderlay';
import CloseNavigationMenu from '../NavigationMenu/mobile/styled/CloseNavigationMenu';
import { NAV_MENU } from '../../helpers/trackingStringValues';
import TrackingEvents from '../../common/models/TrackingEvents';
import Departments from '../../common/models/Departments';
import { updateDepartment } from '../../modules/manageDepartment';
import { DESIGNERS_LIST_PAGE } from '../../helpers/pageHelper';
import { brandsUrl, cart } from '../../helpers/routes';
import setSessionDepartment from '../../common/actions/homeActions';
import NewsletterModalButton from '../NewsletterModalButton';
import withCountryCode from '../RoutesHoc/RoutesHoc';
import ShippingCountry from './ShippingCountry/ShippingCountry';
import { trackAction } from '../../common/actions/trackingActions';

const mapStateToProps = ({
  api: { auth, email, numCartItems, basePath, hoverContent, s3BasePath, page, countryIso },
  department,
}) => ({
  auth,
  basePath,
  hoverContent,
  department,
  s3BasePath,
  page,
  email,
  countryIso,
  numCartItems,
});

const mapDispatchToProps = dispatch => ({
  setDepartment: (department, e, setSession = false) => {
    if (setSession) {
      dispatch(setSessionDepartment(department));
    } else {
      dispatch(updateDepartment(department));
    }
  },
  track: (eventType, payload) => dispatch(trackAction(eventType, payload)),
});

class HeaderComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileNavigationMenu: false,
      department: Departments.getInternalName(props.department),
      initialDepartment: Departments.getInternalName(props.department),
      searchQuery: '',
      searchDepartment: Departments.getInternalName(props.department),
      showsDepartment: false,
    };

    this.setDepartmentState = this.setDepartmentState.bind(this);
    this.toggleNavigationMenu = this.toggleNavigationMenu.bind(this);
  }

  setDepartmentState(selectedDepartment, e) {
    this.setState({ department: selectedDepartment, searchDepartment: selectedDepartment });
  }

  toggleNavigationMenu() {
    const { track } = this.props;

    if (!this.state.navigationMenu) {
      track(TrackingEvents.modalOpened(), { ui: { type: NAV_MENU } });
    }
    this.setState({
      showMobileNavigationMenu: !this.state.showMobileNavigationMenu,
      searchBarVisible: false,
    });
  }

  render() {
    const { setDepartment, numCartItems, s3BasePath, currPage, buildUrlWithCountry, countryIso } = this.props;
    const {
      department,
      showMobileNavigationMenu,
      searchBarVisible,
      resetDepartment,
      initialDepartment,
      searchDepartment,
      searchQuery,
      showsDepartment,
    } = this.state;

    return (
      <div
        onMouseEnter={() => this.setState({ resetDepartment: false })}
        onMouseLeave={() => this.setState({ resetDepartment: true })}
      >
        <Mobile>
          <NavigationMenuUnderlay open={showMobileNavigationMenu} />
          <NavigationMenuMobile
            department={department}
            isOpen={showMobileNavigationMenu}
            toggle={this.toggleNavigationMenu}
            handleClickDepartment={this.setDepartmentState}
            initialDepartment={initialDepartment}
          />
          <CloseNavigationMenu
            onClick={this.toggleNavigationMenu}
            src={`${s3BasePath}mkt/icon/x_grey.png`}
            visible={showMobileNavigationMenu}
          />
          {searchBarVisible && (
            <SearchBox
              department={searchDepartment}
              showDepartments={showsDepartment}
              s3BasePath={s3BasePath}
              setDepartmentVisibility={v => this.setState({ showsDepartment: v })}
              searchQuery={searchQuery}
              queryUpdated={q => this.setState({ searchQuery: q })}
              departmentUpdated={d => this.setState({ searchDepartment: d })}
              hideSearchBox={() => this.setState({ searchBarVisible: false })}
              mobileSubmit
            />
          )}
          <ShippingCountry />
        </Mobile>
        <HeaderWrapper>
          <div>
            <LogoRow>
              <LeftColumn>
                <Mobile>
                  <Hamburger
                    data-cy="navigation-menu"
                    onClick={this.toggleNavigationMenu}
                    src={`${s3BasePath}mkt/header_mobile/hamburger.svg`}
                  />
                </Mobile>
                <Desktop>
                  <NewsletterModalButton header />
                </Desktop>
              </LeftColumn>

              <Logo s3BasePath={s3BasePath} />

              <RightColumn>
                <Desktop>
                  <ShippingCountry />
                  <ActionLinks />
                </Desktop>
                <Mobile>
                  <MagnifyingGlass
                    data-cy="image-search-open"
                    src={`${s3BasePath}mkt/header/magnifying_glass.svg`}
                    onClick={() => this.setState({ searchBarVisible: !searchBarVisible })}
                  />
                </Mobile>
                <ShoppingBag href={buildUrlWithCountry(cart)} s3BasePath={s3BasePath}>
                  <ShoppingBagText data-cy="shopping-bag-cart-num-items">{numCartItems}</ShoppingBagText>
                </ShoppingBag>
              </RightColumn>
            </LogoRow>

            <Desktop>
              <NavigationRow>
                <DepartmentBox
                  context="nav"
                  resetDepartment={resetDepartment}
                  initialDepartment={initialDepartment}
                  department={department}
                  handleHover={this.setDepartmentState}
                  handleClick={(selectedDepartment, e) => {
                    if (currPage === DESIGNERS_LIST_PAGE) {
                      window.location = buildUrlWithCountry(`${brandsUrl}/${selectedDepartment}`);
                    } else {
                      setDepartment(selectedDepartment, e, true);
                    }
                  }}
                />
                <div style={{ flex: 1 }} />
                <SearchBox
                  department={searchDepartment}
                  showDepartments={showsDepartment}
                  s3BasePath={s3BasePath}
                  setDepartmentVisibility={v => this.setState({ showsDepartment: v })}
                  searchQuery={searchQuery}
                  queryUpdated={q => this.setState({ searchQuery: q })}
                  departmentUpdated={d => this.setState({ searchDepartment: d })}
                />
              </NavigationRow>
              <NavigationRow>
                <NavigationMenuDesktop
                  department={department}
                  hoverShown={() => this.setState({ showsDepartment: false })}
                />
              </NavigationRow>
            </Desktop>
          </div>
        </HeaderWrapper>
      </div>
    );
  }
}

HeaderComp.propTypes = {
  basePath: PropTypes.string,
  numCartItems: PropTypes.number,
  department: PropTypes.string,
  s3BasePath: PropTypes.string,
  setDepartment: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
};

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComp);
export default withCountryCode(Header);
